import React, { useContext, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import moment from 'moment'
import { EPCRContext } from '../../EPCR'
import AirwayAssess from './AirwayAssess'
import AirwayRx from './AirwayRx'
import Breathing from './Breathing'
import Circulation from './Circulation'

const PrimarySurvey = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment()
  })
  const { handleChange, formValues } = useContext(EPCRContext)

  return (
    <Stack gap={2} padding={1} component={Paper}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Primary Survey</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime ?? moment()}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <AirwayAssess
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <AirwayRx
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Breathing
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Circulation
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button onClick={() => submitModule('Primary Survey', moduleValues)} variant="contained" color="success" fullWidth>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default PrimarySurvey
